import { signatureFontFiles } from "./signatureFonts";

let fontRequest;
const signatureFontRequests = new Map();

export const loadSignaturePdfFonts = async signatures => {
  const names = [
    ...new Set(
      signatures.map(signature => (signature.font || "Pacifico").trim())
    )
  ];
  const entries = await Promise.all(
    names.map(async name => {
      const file = Object.prototype.hasOwnProperty.call(
        signatureFontFiles,
        name
      )
        ? signatureFontFiles[name]
        : null;
      if (!file)
        throw new Error(`The saved signature font "${name}" is unavailable.`);
      if (!signatureFontRequests.has(name)) {
        const request = fetch(
          `${process.env.BASE_URL}fonts/signatures/${file}.ttf`
        )
          .then(async response => {
            if (!response.ok)
              throw new Error(
                `Could not load the ${name} signature font. Please retry.`
              );
            const bytes = new Uint8Array(await response.arrayBuffer());
            if (bytes.length < 10000 || bytes[0] !== 0 || bytes[1] !== 1)
              throw new Error(
                `The ${name} signature font is unavailable. Please retry.`
              );
            let binary = "";
            for (let i = 0; i < bytes.length; i += 8192)
              binary += String.fromCharCode(...bytes.subarray(i, i + 8192));
            return { family: `NvokoSignature-${file}`, data: btoa(binary) };
          })
          .catch(error => {
            signatureFontRequests.delete(name);
            throw error;
          });
        signatureFontRequests.set(name, request);
      }
      return [name, await signatureFontRequests.get(name)];
    })
  );
  return Object.fromEntries(entries);
};

export const loadModernPdfFonts = () => {
  if (!fontRequest) {
    const styles = {
      normal: "Regular",
      bold: "Bold",
      italic: "Italic",
      bolditalic: "BoldItalic"
    };
    fontRequest = Promise.all(
      Object.entries(styles).map(async ([style, file]) => {
        const response = await fetch(
          `${process.env.BASE_URL}fonts/plus-jakarta-sans/${file}.ttf`
        );
        if (!response.ok)
          throw new Error("Could not load the Modern PDF font. Please retry.");
        const bytes = new Uint8Array(await response.arrayBuffer());
        if (bytes.length < 10000 || bytes[0] !== 0 || bytes[1] !== 1)
          throw new Error("The Modern PDF font is unavailable. Please retry.");
        let binary = "";
        for (let i = 0; i < bytes.length; i += 8192)
          binary += String.fromCharCode(...bytes.subarray(i, i + 8192));
        return [style, btoa(binary)];
      })
    )
      .then(Object.fromEntries)
      .catch(error => {
        fontRequest = null;
        throw error;
      });
  }
  return fontRequest;
};
